import { Autocomplete as MuiAutocomplete } from '@material-ui/lab';
import PropTypes from 'prop-types';

import TextField from './TextField';

const Autocomplete = ({ inputProps, label, completed, ...props }) => (
  <MuiAutocomplete
    style={{ height: '100%', fontFamily: 'Roboto' }}
    renderInput={(params) => (
      <TextField label={label} completed={completed} {...params} {...inputProps} />
    )}
    size="small"
    {...props}
  />
);

Autocomplete.propTypes = {
  label: PropTypes.node,
  inputProps: PropTypes.object,
};

export default Autocomplete;
